import { addDays, subYears, endOfYear, endOfMonth, startOfYear, endOfQuarter, startOfMonth, startOfQuarter } from 'date-fns';
import { formatDateLong, toDatestampArray } from '~/models/time';
import { formatNumericUSDate } from '~/utils';
import { DateRange } from '../types';
export const dateRangeOptions = [
    {
        value: DateRange.Last12Months,
        text: 'Last 12 months'
    },
    {
        value: DateRange.CurrentMonth,
        text: 'This month'
    },
    {
        value: DateRange.CurrentQuarter,
        text: 'This quarter'
    },
    {
        value: DateRange.CurrentYear,
        text: 'This year'
    },
    {
        value: DateRange.AllTime,
        text: 'All time'
    },
    {
        value: DateRange.Custom,
        text: 'Custom'
    }
];
export const dataRangeNames = {
    [DateRange.Last12Months]: ()=>'Last 12 months',
    [DateRange.CurrentMonth]: ()=>'This month',
    [DateRange.CurrentQuarter]: ()=>'This quarter',
    [DateRange.CurrentYear]: ()=>'This year',
    [DateRange.AllTime]: ()=>'All time',
    [DateRange.Custom]: (start, end)=>"Custom range (".concat(dateToStr(start), " - ").concat(dateToStr(end), ")")
};
export const dateToStr = (date)=>formatDateLong(toDatestampArray(new Date(date)));
export function calculateEndDate(endDate, dataRange, now) {
    switch(dataRange){
        case DateRange.Last12Months:
            return formatNumericUSDate(now);
        case DateRange.CurrentMonth:
            return formatNumericUSDate(endOfMonth(now));
        case DateRange.CurrentQuarter:
            return formatNumericUSDate(endOfQuarter(now));
        case DateRange.CurrentYear:
            return formatNumericUSDate(endOfYear(now));
        case DateRange.AllTime:
            return '';
        default:
            return endDate;
    }
}
export function calculateStartDate(startDate, dataRange, now) {
    switch(dataRange){
        case DateRange.Last12Months:
            return formatNumericUSDate(addDays(subYears(now, 1), 1));
        case DateRange.CurrentMonth:
            return formatNumericUSDate(startOfMonth(now));
        case DateRange.CurrentQuarter:
            return formatNumericUSDate(startOfQuarter(now));
        case DateRange.CurrentYear:
            return formatNumericUSDate(startOfYear(now));
        case DateRange.AllTime:
            return formatNumericUSDate(new Date('2023-01-01'));
        default:
            return startDate;
    }
}
